/** @format */

import { Resource, UserResource } from "../features/resources/types";

/**
 * returns the correct resource code.
 * includes checking for the code in the Object when a legacy resource did not save it to the root
 */
export function getResourceCode(resource: Resource | UserResource): string {
  return resource.Code !== undefined && resource.Code !== null
    ? resource.Code
    : (resource.Object as any).code; // use the legacy code location
}
